module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/Uncaught-SyntaxError-Unexpected-token-export-16.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/Uncaught-SyntaxError-Unexpected-token-export.md
// module id = 586
// module chunks = 473